"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var contentCache = [];

var set = function set(unitKey, unitRevision, flatten, promise) {
  var foundCache = get(unitKey, unitRevision, flatten);

  if (foundCache.promise === undefined) {
    contentCache.push({
      unitKey: unitKey,
      unitRevision: unitRevision,
      flatten: flatten,
      promise: promise
    });
  }
};

var get = function get(unitKey, unitRevision, flatten) {
  var fromCache = _lodash["default"].find(contentCache, function (cache) {
    return cache.unitKey === unitKey && cache.unitRevision === unitRevision && cache.flatten === flatten;
  });

  return fromCache ? fromCache : {};
};

var remove = function remove(unitKey, unitRevision, flatten) {
  _lodash["default"].remove(contentCache, function (cache) {
    return cache.unitKey === unitKey && cache.unitRevision === unitRevision && cache.flatten === flatten;
  });
};

var _default = {
  set: set,
  get: get,
  remove: remove
};
exports["default"] = _default;